import { render, staticRenderFns } from "./PdfDownloadTable.vue?vue&type=template&id=153a1e72&"
import script from "./PdfDownloadTable.vue?vue&type=script&lang=ts&"
export * from "./PdfDownloadTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports